import { render, staticRenderFns } from "./myGrades.vue?vue&type=template&id=08f961e4&scoped=true"
import script from "./myGrades.vue?vue&type=script&lang=js"
export * from "./myGrades.vue?vue&type=script&lang=js"
import style0 from "./myGrades.vue?vue&type=style&index=0&id=08f961e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f961e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f961e4')) {
      api.createRecord('08f961e4', component.options)
    } else {
      api.reload('08f961e4', component.options)
    }
    module.hot.accept("./myGrades.vue?vue&type=template&id=08f961e4&scoped=true", function () {
      api.rerender('08f961e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/concatTeacher/myGrades.vue"
export default component.exports